<template>
  <!-- Authors Table Card -->
  <div>
    <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: 0 }">
      <template #title>
        <a-row type="flex" align="middle">
          <a-col :span="24" :md="12">
            <h5 class="font-semibold m-0">用户管理</h5>
          </a-col>
          <a-col :span="24" :md="12" style="
              display: flex;
              align-items: center;
              justify-content: flex-end;
            ">
            <a-button type="primary" class="add-shop" @click="() => (modal2Visible = true)">
              新增用户
            </a-button>
          </a-col>
        </a-row>
      </template>
      <a-table :columns="columns" :data-source="data" :pagination="true">
        <template slot="author" slot-scope="author">
          <div class="table-avatar-info">
            <a-avatar shape="square" :src="author.avatar" />
            <div class="avatar-info">
              <h6>{{ author.name }}</h6>
              <p>{{ author.email }}</p>
            </div>
          </div>
        </template>
        <template slot="website" slot-scope="website">
          <div class="author-info">
            <div class="website-tags">
              <div v-for="(domain, index) in website.split(',')" :key="domain">
                <a-tag 
                  class="website-tag"
                  @click="copyDomain(domain)"
                  color="blue"
                >
                  {{ domain }}
                </a-tag>
              </div>
            </div>
          </div>
        </template>
        <template slot="expiry_time" slot-scope="expiry_time">
          <div class="author-info">
            <h6 class="m-0" :class="{ 'text-red': isExpiringSoon(expiry_time) }">{{ expiry_time }}</h6>
          </div>
        </template>


        <template slot="status" slot-scope="status">
          <a-tag class="tag-status" :class="status ? 'ant-tag-primary' : 'ant-tag-muted'">
            {{ status ? "有效" : "失效" }}
          </a-tag>
        </template>

        <template slot="cloak" slot-scope="cloak">
          <a-tag class="tag-status" :class="cloak ? 'ant-tag-success' : 'ant-tag-default'">
            {{ cloak ? "已开启" : "已关闭" }}
          </a-tag>
        </template>

        <template slot="editBtn" slot-scope="row">
          <div style="white-space: pre">
            <a-button type="link" :data-id="row.key" class="btn-edit" @click="truePass(row)">
              真实密码
            </a-button>
            <a-button type="link" :data-id="row.key" class="btn-edit" @click="openEdit(row)">
              编辑域名
            </a-button>
            <a-button type="link" :data-id="row.key" class="btn-edit" @click="toggleCloak(row)">
              {{ row.cloak ? '关闭斗篷' : '开启斗篷' }}
            </a-button>
            <a-button type="link" :data-id="row.key" class="btn-edit" @click="openEditPass(row)">
              修改密码
            </a-button>
            <a-button type="link" :data-id="row.key" class="btn-edit" @click="openEditDays(row)">
              续期
            </a-button>
            <a-popconfirm title="确定要删除此用户吗?" ok-text="确定" cancel-text="取消" @confirm="deleteUser(row)">
              <a-button type="link" :data-id="row.key" style="color:red;">
                删除
              </a-button>
            </a-popconfirm>

          </div>
        </template>
      </a-table>
    </a-card>
    <!-- 新增用户 -->
    <a-modal v-model="modal2Visible" title="新增用户" centered cancelText="取消" okText="确认" @ok="addUser">
      <a-form-model :model="form">
        <a-form-model-item label="用户昵称">
          <a-input v-model="form.username" @blur="
            () => {
              $refs.name.onFieldBlur();
            }
          " />
        </a-form-model-item>
        <a-form-model-item ref="name" label="用户密码" prop="password">
          <a-input v-model="form.password" @blur="
            () => {
              $refs.name.onFieldBlur();
            }
          " />
        </a-form-model-item>
        <a-form-model-item label="分配域名">
          <a-select v-model="form.website" placeholder="请选择分配域名" mode="multiple">
            <a-select-option v-for="domain in domains" :key="domain" :value="domain">
              {{ domain }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="到期时间">
          <a-date-picker v-model="date1" show-time type="date" placeholder="Pick a date" style="width: 100%" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 分配域名 -->
    <a-modal v-model="editUserVisible" title="编辑用户" centered cancelText="取消" okText="确认" @ok="editUser">
      <a-form-model :model="form">
        <a-form-model-item label="用户昵称">
          <a-input v-model="editForm.username" disabled="true" @blur="
            () => {
              $refs.name.onFieldBlur();
            }
          " />
        </a-form-model-item>
        <a-form-model-item label="分配域名">
          <a-select v-model="editForm.website" :value="editForm.website" placeholder="请选择分配域名" mode="multiple">
            <a-select-option v-for="domain in domains" :key="domain" :value="domain">
              {{ domain }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 修改密码 -->
    <a-modal v-model="editPassVisible" title="修改密码" centered cancelText="取消" okText="确认" @ok="editUser">
      <a-form-model :model="form">
        <a-form-model-item label="用户昵称">
          <a-input v-model="editForm.username" disabled="true" @blur="
            () => {
              $refs.name.onFieldBlur();
            }
          " />
        </a-form-model-item>
        <a-form-model-item ref="name" label="用户密码" prop="password">
          <a-input v-model="editForm.password" @blur="
            () => {
              $refs.name.onFieldBlur();
            }
          " />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 续期 -->
    <a-modal v-model="editDaysVisible" title="续期" centered cancelText="取消" okText="确认" @ok="editUser">
      <a-form-model :model="form">
        <a-form-model-item label="用户昵称">
          <a-input v-model="editForm.username" disabled="true" @blur="
            () => {
              $refs.name.onFieldBlur();
            }
          " />
        </a-form-model-item>
        <a-form-model-item label="到期时间">
          <a-date-picker v-model="editForm.days" show-time type="date" placeholder="Pick a date" style="width: 100%" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 斗篷确认 -->
    <a-modal v-model="cloakConfirmVisible" :title="cloakTitle" centered cancelText="取消" okText="确认" @ok="updateCloak">
      <p>{{ cloakConfirmText }}</p>
    </a-modal>
  </div>

  <!-- / Authors Table Card -->
</template>

<script>
import moment from "moment";
import { domainlist, register, updateuser, deleteuser, adminLogin } from "@/api/user";

export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => [],
    },
  },
  created() {
    this.getAllDoamins();
  },
  data() {
    return {
      // Active button for the "Authors" table's card header radio button group.
      authorsHeaderBtns: "all",
      modal2Visible: false,
      editUserVisible: false,
      editPassVisible: false,
      editDaysVisible: false,
      cloakConfirmVisible: false,
      cloakTitle: "",
      cloakConfirmText: "",
      domains: [],
      date1: "",
      form: {
        username: "",
        days: "",
        password: "",
        website: [],
        cloak: false,
      },
      editForm: {
        username: "",
        website: [],
        password: "",
        days: "",
        cloak: false,
      },
    };
  },
  computed: {
    // Compute the data to display based on current page and page size
    displayData() {
      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      return this.data.slice(startIndex, endIndex);
    },
  },
  watch: {
    date1(newDate) {
      if (newDate) {
        this.calculateDaysDifference(newDate);
      }
    },
  },
  methods: {
    // Handle page change
    handlePageChange(page) {
      this.currentPage = page;
    },
    setModal1Visible(modal1Visible) {
      this.modal1Visible = modal1Visible;
    },
    calculateDaysDifference(date) {
      const selectedDate = moment(date);
      const currentDate = moment();
      const difference = selectedDate.diff(currentDate, "days");
      this.form.days = difference;
    },
    getAllDoamins() {
      domainlist().then((res) => {
        this.domains = res.data.available_domains;
      });
    },
    addUser() {
      console.log(this.form);
      register(this.form).then((res) => {
        this.modal2Visible = false;
        this.$message.success("新增用户成功！");
        this.$emit("getUsers");
      });
    },
    editUser() {
      let updateForm = {}
      updateForm.username = this.editForm.username;
      if (this.editForm.days != "") {
        const selectedDate = moment(this.editForm.days);
        const currentDate = moment();
        const difference = selectedDate.diff(currentDate, "days");
        updateForm.days = difference;
      }
      switch (this.modalTitle) {
        case "编辑用户":
          updateForm.website = this.editForm.website
          break;
        case "编辑密码":
          updateForm.password = this.editForm.password
          break;
        case "斗篷设置":
          updateForm.cloak = this.editForm.cloak
          break;
      }

      updateuser(updateForm).then((res) => {
        this.editUserVisible = false;
        this.editPassVisible = false;
        this.editDaysVisible = false;
        this.$message.success("修改成功！");
        this.$emit("getUsers");
      });
    },
    deleteUser(row) {
      console.log(row)
      deleteuser({ username: row.username }).then((res) => {
        if (res.status != 200) return this.$message.error("删除失败！");
        this.$message.success("删除成功！");
        this.$emit("getUsers");
      });

    },
    openEdit(row) {

      this.modalTitle = "编辑用户";
      this.editForm.website = row.website.length ? row.website.split(",") : [];
      this.editForm.username = row.username;
      this.editUserVisible = true;
    },
    openEditPass(row) {
      this.modalTitle = "编辑密码";
      this.editForm.username = row.username;
      this.editForm.website = row.website.length ? row.website.split(",") : [];
      this.editPassVisible = true
    },
    openEditDays(row) {
      this.modalTitle = "续期";
      this.editForm.username = row.username;
      this.editForm.website = row.website.length ? row.website.split(",") : [];
      this.editDaysVisible = true
    },
    isExpiringSoon(expiry_time_str) {
      // 将到期时间字符串转换为日期对象
      let expiryDate = new Date(expiry_time_str);

      // 获取当前时间
      let currentDate = new Date();

      // 计算到期时间与当前时间的时间差（毫秒数）
      let timeDifference = expiryDate.getTime() - currentDate.getTime();

      // 将时间差转换为天数
      let daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

      // 判断是否低于7天
      return daysDifference < 7;
    },
    truePass(row) {
      adminLogin({ username: row.username }).then(res => {
        if (res.status == 200) {
          const token = res.data.token
          window.open(process.env.VUE_APP_URL.replace("/api","/dashboard") + "?token=" + token)
        }

      })
    },
    copyDomain(domain) {
      navigator.clipboard.writeText(domain).then(() => {
        this.$message.success('域名已复制到剪贴板');
      }).catch(() => {
        this.$message.error('复制失败，请手动复制');
      });
    },
    toggleCloak(row) {
      this.editForm.username = row.username;
      this.editForm.cloak = !row.cloak;
      this.modalTitle = "斗篷设置";
      this.cloakTitle = this.editForm.cloak ? "开启斗篷" : "关闭斗篷";
      this.cloakConfirmText = this.editForm.cloak 
        ? `确定要为用户 ${row.username} 开启斗篷吗？` 
        : `确定要为用户 ${row.username} 关闭斗篷吗？`;
      this.cloakConfirmVisible = true;
    },
    updateCloak() {
      let updateForm = {
        username: this.editForm.username,
        cloak: this.editForm.cloak
      };
      
      updateuser(updateForm).then((res) => {
        this.cloakConfirmVisible = false;
        this.$message.success(this.editForm.cloak ? "斗篷已开启！" : "斗篷已关闭！");
        this.$emit("getUsers");
      }).catch(err => {
        this.$message.error("操作失败！");
      });
    },
  },
  mounted() {
    this.getAllDoamins();
  },
};
</script>
<style lang="css" scoped>
.btn-edit {
  color: blue;
}

.text-red {
  color: red;
}

.website-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.website-tag {
  cursor: pointer;
  margin: 0;
  padding: 2px 8px;
  border-radius: 4px;
  transition: all 0.3s;
}

.website-tag:hover {
  opacity: 0.8;
}

.ant-tag-success {
  color: #52c41a;
  background: #f6ffed;
  border-color: #b7eb8f;
}

.ant-tag-default {
  color: #d9d9d9;
  background: #fafafa;
  border-color: #d9d9d9;
}
</style>
